module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAUCAYAAABbLMdoAAAA90lEQVR42mLUXvyegVjAhEPcEIjZiFHMC8RrgbiRGMV9QKwIxKVAbIFPsRcQJ0PZzEC8CIi5sSkWAuI5QMyIJKYKxO3YFE8FYkkszsoBYmdkxaFAHIEjZEA2zQNifpBiCSCeTiCI5YC4nwVIfAViM2IiBaT4MxQTBIz///8nOrpZpk+frgWkF6IFGTZwGWwyUAMo2LLwKPwFxOawoCsD4jt4FDdnZmZeACsGMkAhEg/Ef7EoPAWLRXgMAjUcA1K9aAq/A3EcUO4vtoRUB8RXkPhVQIU3saY6oMRPkElA/BuIDwDxRBSjQKGBjqdNm1YIxAro4gABBgDjxlJ1uXL7MwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/up.png
// module id = WY0H
// module chunks = 1